import React, { useState } from "react";

import {
    ConsentOption,
    ConsentSelection,
    emptyConsentSelection,
    toggleConsentSelection,
    validateConsentSelection,
} from "./consentLogic";

/**
 * Checkbox state for one summary exit's consent section. All three exits (mail, send-to-shop,
 * send-to-parent) share it so they cannot drift on when a required consent blocks the send or when the
 * error styling clears — the gating is GDPR-relevant, so one copy of it is the point. The transitions
 * themselves live in consentLogic, which is React-free and therefore unit-testable; this hook only
 * holds the state and adapts the DOM event.
 */
export const useConsentSelection = (options: ConsentOption[]) => {
    const [selection, setSelection] = useState<ConsentSelection>(emptyConsentSelection);

    const toggleConsent = (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = event.target;
        setSelection(prev => toggleConsentSelection(prev, key, checked));
    };

    // Marks the unticked required consents for the error box and reports whether the send may proceed
    // — it writes state, so it is a validate step, not a pure predicate.
    const validateRequiredConsents = () => {
        const { selection: validated, canSend } = validateConsentSelection(selection, options);
        setSelection(validated);
        return canSend;
    };

    return {
        checkedConsents: selection.checked,
        consentErrors: selection.errors,
        toggleConsent,
        validateRequiredConsents,
    };
};
